/** GraphQL `stage` — ровно то, что нужно, чтобы решить, сколько картинок таблицы рисовать. */
export interface StageRenderTargetsGql {
  id: number;
  /** `StageType` строкой: `GROUP`, `ROUND_ROBIN_1`, … */
  type: string;
  teamGroups: StageRenderTargetGroupGql[] | null;
}

export interface StageRenderTargetGroupGql {
  id: number;
  name: string;
  sortOrder: number | null;
  createdAt: string;
  stage: { id: number };
}

export const STAGE_RENDER_TARGETS_QUERY = `#graphql
  query stageRenderTargets($stageId: Int!) {
    stage(id: $stageId) {
      id
      type
      teamGroups {
        id
        name
        sortOrder
        createdAt
        stage { id }
      }
    }
  }
`;
